import { createAction } from 'redux-actions';

export const add = createAction('HISTORY/ADD', (listingId) => ({
  listingId,
}));
export const addSuccess = createAction('HISTORY/ADD_SUCCESS', (history) => ({
  history,
}));
export const load = createAction('HISTORY/LOAD');
export const loadSuccess = createAction('HISTORY/LOAD_SUCCESS', (history) => ({
  history,
}));

export default {
  add,
  addSuccess,
  load,
  loadSuccess,
};
